import { Color, DateTimeFormat } from '@billy/design-system'
import { memo, ReactElement, ReactNode } from 'react'

import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { getCurrentLocale } from '../../../utils'
import { formatDate } from '../../../utils/date-fns'
import * as Styled from './styles'

interface DateFormatterProps {
  children?: ReactNode
  color?: Color
  dateFormat?: string
  value: string | Date
  withHour?: boolean
}

const getLocalizedDisplayDate = (value: string | Date, locale: LocaleIdentifier, withHour?: boolean) =>
  withHour
    ? DateTimeFormat.getFormattedDateTime(value, locale, { dateStyle: 'short', timeStyle: 'medium' })
    : DateTimeFormat.getFormattedDate(value, locale)

export const DateFormatter = memo(
  ({ children, color, dateFormat, value, withHour }: DateFormatterProps): ReactElement => {
    const fullDate = formatDate(value, 'yyyy-MM-dd HH:mm:ss')
    const locale = getCurrentLocale()
    const displayDate = dateFormat ? formatDate(value, dateFormat) : getLocalizedDisplayDate(value, locale, withHour)

    return (
      <Styled.DateFormatterWrapper dateTime={fullDate} color={color}>
        {children || displayDate}
      </Styled.DateFormatterWrapper>
    )
  },
)
